/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Control } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/community/topcommenters/topcommenters_styles';



/* ========== ~~~~~~~~~~ ADD-ON COMMUNITY TOP COMMENTERS ~~~~~~~~~~ ========== */
const TopCommenters = props => {

    const topCommentersOptions = [2, 6, 10, 14, 18, 20];

    const handleSelect = value => {
        props.onChange(value);
    }

    return (
        <div className={`topcommenters ${props.classes.topcommenters} section`}>
            <div className={`sectioncontent`}>
                { topCommentersOptions.map(value =>
                    <Control 
                        text={value.toString()} 
                        value={value} 
                        handleSelect={() =>  handleSelect(value)} 
                        variant={'secondary'} 
                        selected={props.data.topCommentersInitialLoadLimit === value}  
                    />
                )}
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(TopCommenters);